'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotContourIcon = function PlotContourIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M11.188 4c4.938 0 10.688 1.625 13.063 3.75 2.938 2.5 4.813 6 5.063 9.875.313 2.375-.625 4.75-2.25 6.625-3.188 2.813-7.313 4.313-11.625 4.313-2.875.125-5.688-.938-7.813-2.938-5.75-5.75-6.688-16.313-3.25-19.75C5.626 4.687 8.001 4 11.189 4m-.001-1.312c-3.188 0-6.125.625-7.75 2.25-4.125 4-2.75 15.438 3.25 21.438a11.902 11.902 0 0 0 8.75 3.375c4.563 0 9.125-1.625 12.563-4.688 4.125-4.125 3.75-12.938-2.813-18.5-2.625-2.313-8.813-3.875-14-3.875zm1.75 6.375c3.875 0 7.188 1.063 8.125 2 1.625 1.5 2.375 3.5 2.375 5.625.188 1.875-.5 3.688-1.813 5.063-1.25 1.063-2.813 1.688-4.563 1.563-2.25 0-4.375-.938-6-2.5-3.75-3.75-5.438-8.688-3.625-10.563.813-.5 2.438-1.188 5.5-1.188m.001-1.313c-2.688 0-5.063.5-6.25 1.563C4 12.001 6.25 17.876 10.251 21.751c1.875 1.875 4.313 2.938 6.938 2.938 2 0 4-.688 5.5-2.125 3.188-3.75 2.938-9.25-.688-12.688-1.438-1.188-5.438-2.125-9.063-2.125zm2 4.625c.5 0 1.063.313 1.438.563 1.875 1.875 2.813 4.5 2.563 4.938a2.002 2.002 0 0 1-1.75 1.063c-1.063-.125-2.125-.688-2.938-1.313-2.25-1.875-2.375-3.063-2.25-3.875 0-.125.125-.313.125-.313.688-.625 1.75-1.063 2.813-1.063m-.001-1.312c-1.875 0-4 1.063-4.25 2.125-.688 2 .625 3.75 2.625 5.375a7.121 7.121 0 0 0 3.875 1.563c1.188 0 2.25-.5 2.813-1.438.938-1.5-.813-4.813-2.688-6.688-.625-.563-1.438-1.063-2.375-.938' })
    );
};

exports.default = PlotContourIcon;